$(document).ready(() => {
  let wWidth = $(window).width();
  const $header = $('.page-header');
  const headerHeight = $header.height();
  const $body = $('body');
  // const $popup = $('.popup');
  let isObserver = true;
  let observer;
  let navState = false;
  let isScrollingDisabled = false;
  let lastSrollTop = 0;

  if (
    !('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('isIntersecting' in window.IntersectionObserverEntry.prototype)
  ) {
    isObserver = false;
    $('html').removeClass('is-observer');
  }

  if (isObserver) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {rootMargin: '0px 0px -15% 0px'}
    );
  }

  // if (isTouchDevice()) {
  //   isTouch = true;
  //   $('html').addClass('is-touch');
  // }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate, ...args) {
    let timeout;
    return function () {
      const context = this;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function disableScrolling() {
    const docHeight = document.body.clientHeight;
    const windowHeight = window.innerHeight;

    if (docHeight > windowHeight) {
      const html = document.documentElement;
      const {scrollTop} = html;
      html.classList.add('disable-scrolling');
      html.style.top = `${-scrollTop}px`;
      isScrollingDisabled = true;
    }
  }

  function enableScrolling() {
    const {top} = getComputedStyle(document.documentElement);
    const scrollTop = parseInt(top, 10);
    const html = document.documentElement;
    html.classList.remove('disable-scrolling');
    html.scrollTop = -scrollTop;
    isScrollingDisabled = false;
  }

  const initHeader = () => {
    const $nav = $header.find('.page-header__menu');
    const $parentLi = $nav.find('.menu-item-has-children');
    const $parentLinks = $parentLi.children('a');
    const $hamburger = $header.find('.page-header__hamburger');
    const $btn = $header.find('.page-header__btn');

    function handleNavTouch(e) {
      const $item = $(e.target);

      if ($item.parent().hasClass('is-opened')) {
        $item.parent().removeClass('is-opened');
      } else {
        $parentLi.removeClass('is-opened');
        $item.parent().addClass('is-opened');
      }
    }

    $parentLinks.on('touchend', (e) => {
      e.preventDefault();
      handleNavTouch(e);
    });

    /* Navigation with tabbing */
    $(window).keyup((e) => {
      const code = e.keyCode ? e.keyCode : e.which;

      if (code === 9) {
        if ($parentLinks.filter(':focus').length) {
          handleNavTouch(e);
        } else {
          const link = $nav.find('a:focus');

          if (
            link.length &&
            !link.parent().hasClass('.menu-item-has-children') &&
            !link.closest('.sub-menu').length
          ) {
            $parentLi.removeClass('is-opened');
          }
        }
      }
    });

    $nav.on('click', (e) => {
      e.stopPropagation();
    });

    $(document).on('click', () => {
      if ($parentLi.hasClass('is-opened')) {
        $parentLi.removeClass('is-opened');
      }
    });

    $hamburger.on('click', () => {
      if (!navState) {
        $header.addClass('is-opened');
        $body.removeClass('is-popup');

        if (wWidth < 1024 && !isScrollingDisabled) {
          disableScrolling();
        }
      } else {
        $header.removeClass('is-opened');

        if (wWidth < 1024 && isScrollingDisabled) {
          enableScrolling();
        }
      }

      navState = !navState;
    });


    $btn.on('click', () => {

      if (!$body.hasClass('is-popup')) {
        $body.addClass('is-popup');
        $header.removeClass('is-opened');
        navState = false;
        if (!isScrollingDisabled) {
          disableScrolling();
        }
      } else {
        $body.removeClass('is-popup');
        if (isScrollingDisabled) {
          enableScrolling();
        }
      }

    });
  };

  const closePopup = (popup, e) => {
    console.log(popup);
    // e.preventDefault();
    popup.removeClass('is-visible');
    enableScrolling();
  };

  const initPromotionalPopup = () => {
    const promotionalShown = sessionStorage.getItem('promotionalShown');
    const $popupPromotional = $('.popup-promotional');
    const $closeBtn = $popupPromotional.find('.popup-promotional__close');

    $closeBtn.on('click', e => {
      closePopup($popupPromotional, e);
    });

    $(window).on('click', e => {
      if ($(e.target).is($popupPromotional)) {
        closePopup($popupPromotional, e);
      }
    });

    $(document).on('keyup', function (e) {
      if (e.key === 'Escape') {
        closePopup($popupPromotional, e);
      }
    });

    if (promotionalShown) {
      return;
    }

    if ($popupPromotional.hasClass('is-active')) {

      if ($body.hasClass('is-front-page')) {

        window.onscroll = function () {

          if ($(this).scrollTop() > 550 && !sessionStorage.getItem('promotionalShown')) {
            sessionStorage.setItem('promotionalShown', 'true');
            $popupPromotional.addClass('is-visible');
            disableScrolling();
          }
        };
      } else {
        window.onload = function () {
          setTimeout(function () {
            sessionStorage.setItem('promotionalShown', 'true');
            $popupPromotional.addClass('is-visible');
            disableScrolling();
          }, 500);
        };
      }
    }
  };

  function bindEvents() {
    // FOCUS STYLING
    // Let the document know when the mouse is being used
    document.body.addEventListener('mousedown', () => {
      document.body.classList.remove('is-tab');
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        document.body.classList.add('is-tab');
      }
    });

    // hero btn
    $('.hero__btn').on('click', () => {
      const $next = $('.hero').next();

      $('html,body').animate(
        {
          scrollTop: $next.offset().top,
        },
        1000
      );
    });

    $('.page-footer__btn').on('click', () => {
      $('html,body').animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });

    $('.cta-bar__link').on('click', (e) => {
      const {hash} = e.currentTarget;
      if (hash) {
        const $target = $(hash);
        if ($target.length) {
          e.preventDefault();
          $('html,body').animate(
            {
              scrollTop: $target.offset().top,
            },
            600
          );
        }
      }
    });
  }

  function initCarousel() {
    const $blocks = $('.carousel');
    $blocks.each((i, el) => {
      const $block = $(el);
      const $swiperEl = $block.find('.carousel__swiper');
      const $prev = $block.find('.swiper-controls__prev');
      const $next = $block.find('.swiper-controls__next');

      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper($swiperEl[0], {
        loop: true,
        slidesPerView: 'auto',
        speed: 1000,

        navigation: {
          nextEl: $next[0],
          prevEl: $prev[0],
        },
      });
    });
  }

  function initSlider() {
    const $blocks = $('.slider');
    $blocks.each((i, el) => {
      const $block = $(el);
      const $swiperMediaEl = $block.find('.slider__media');
      const $swiperCopyEl = $block.find('.slider__copy');
      const $prev = $block.find('.swiper-controls__prev');
      const $next = $block.find('.swiper-controls__next');

      const swiperMedia = new Swiper($swiperMediaEl[0], {
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 500,
      });

      const swiperCopy = new Swiper($swiperCopyEl[0], {
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 500,

        navigation: {
          nextEl: $next[0],
          prevEl: $prev[0],
        },
      });

      swiperMedia.controller.control = swiperCopy;
      swiperCopy.controller.control = swiperMedia;
    });
  }

  function initFAQ() {
    const $blocks = $('.faq');
    $blocks.each((i, el) => {
      const $block = $(el);
      const $row = $block.find('.faq__row');
      const $btns = $row.children('.faq__btn');
      const $content = $row.children('.faq__content');

      $btns.on('click', (e) => {
        const $cur = $(e.currentTarget);
        const $curRow = $cur.parent();

        if (!$curRow.hasClass('is-opened')) {
          $row.removeClass('is-opened');
          $content.slideUp();
          $curRow.addClass('is-opened').children('.faq__content').slideDown();
        } else {
          $curRow.removeClass('is-opened').children('.faq__content').slideUp();
        }
      });
    });
  }

  function initFaqParallax() {
    const $blocks = $('.faq');

    $blocks.each((i, el) => {
      const $block = $(el);
      const $img = $block.find('.faq__illustration');
      if ($img.length) {
        gsap.to($img[0], {
          y: '-300%',
          ease: 'linear',
          scrollTrigger: {
            trigger: $block[0],
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        });
      }
    });
  }

  function initParallax() {
    const $blocks = $('.illustration');

    $blocks.each((i, el) => {
      const $block = $(el);
      const $img = $block.children('img');

      gsap.to($img[0], {
        y: '-80%',
        ease: 'linear',
        scrollTrigger: {
          trigger: $block[0],
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    });
  }

  function initStorytellerParallax() {
    const $blocks = $('.card');

    $blocks.each((i, el) => {
      const $block = $(el);
      const $img = $block.find('.card__illustration');

      if ($img.length) {
        const options = {
          ease: 'linear',
          scrollTrigger: {
            trigger: $block[0],
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        };

        if ($img.hasClass('is-vertical')) {
          if ($img.hasClass('is-top')) {
            options.y = '100%';
          } else {
            options.y = '-100%';
          }
        } else if ($block.hasClass('card--reverse')) {
          options.x = '100%';
        } else {
          options.x = '-100%';
        }

        gsap.to($img[0], options);
      }
    });
  }

  function initDoubleImageParallax() {
    const $blocks = $('.double-image');

    $blocks.each((i, el) => {
      const $block = $(el);
      const $img = $block.find('.double-image__illustration');
      if ($img.length) {
        gsap.from($img[0], {
          y: '-100%',
          ease: 'linear',
          scrollTrigger: {
            trigger: $block[0],
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        });
      }
    });
  }

  const initMenuNav = () => {
    const $menuNav = $('.menu-nav');
    if (!$menuNav.length) return;
    const $wrap = $('.menu-flexible-wrap');
    const $container = $menuNav.find('.menu-nav__select-wrap');
    const $btns = $menuNav.find('.menu-nav__btn');
    const $select = $menuNav.find('.menu-nav__select');
    const $headings = $('.section-header');

    // active class on mobile
    ScrollTrigger.create({
      trigger: $wrap[0],
      start: 'top top',
      end: 'bottom top',
      toggleClass: {targets: $container[0], className: 'is-scrolling'},
    });

    // mobile scrolling
    $select.on('change', (e) => {
      const id = $select.val();
      const $target = $(`#${id}`);

      if ($target.length) {
        e.preventDefault();

        $('html,body').animate(
          {
            scrollTop: $target.offset().top - headerHeight - 130,
          },
          1000
        );
      }
    });

    // change select automatically
    $headings.each((i, el) => {
      const $cur = $(el);
      const id = $cur.data('id');

      ScrollTrigger.create({
        trigger: el,
        start: 'top 300px',
        end: 'bottom top',
        onToggle: ({isActive}) => {
          if (isActive) {
            $select.val(id);
          }
        },
      });
    });

    // desktop scrolling
    $btns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const id = $cur.data('id');
      const $target = $(`#${id}`);

      if ($target.length) {
        $('html,body').animate(
          {
            scrollTop: $target.offset().top - headerHeight - 80,
          },
          1000
        );
      }
    });
  };

  const initHomeHeroParallax = () => {
    const $block = $('.hero');
    if (!$block.length) return;
    const $img = $block.find('.hero__bg');

    gsap.to($img[0], {
      y: '20%',
      ease: 'power1.out',
      scrollTrigger: {
        trigger: $block[0],
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  };

  const initPageHeroParallax = () => {
    const $block = $('.hero-page');
    if (!$block.length) return;
    const $img = $block.find('.hero-page__img');

    gsap.to($img[0], {
      y: '20%',
      ease: 'power1.out',
      scrollTrigger: {
        trigger: $block[0],
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  };

  const initBackgroundShift = () => {
    const $blocks = $('.js-bg-shift-start');
    const $footer = $('.page-footer');

    $blocks.each((i, el) => {
      const $triggerStart = $(el);
      const $triggerEnd = $triggerStart.nextAll('.js-bg-shift-end').first();
      const color = $triggerStart.data('color');
      const options = {
        trigger: $triggerStart[0],
        start: 'top center',
        toggleClass: {
          targets: '#content',
          className: `is-scrolling-${color}`,
        },
        endTrigger: $footer[0],
        end: 'bottom top',
      };

      if ($triggerEnd.length) {
        const [triggerEnd] = $triggerEnd;
        options.endTrigger = triggerEnd;
        options.end = 'top center';
      }

      ScrollTrigger.create(options);
    });
  };

  const initGallery = () => {
    const $block = $('.gallery');
    if (!$block.length) return;
    const $btns = $block.find('.gallery__btn');
    const $headerInner = $header.find('.page-header__inner');
    const headerInnerHeight = $headerInner.outerHeight();

    $btns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const id = $cur.data('id');
      const $target = $(`#${id}`);

      if ($target.length) {
        $('html,body').animate(
          {
            scrollTop: $target.offset().top - Math.round(headerInnerHeight),
          },
          1000
        );
      }
    });
  };

  const initAnnouncement = () => {
    const $announcement = $body.find('.announcement');
    const $announcementClose = $announcement.find('.announcement__close-btn');

    $announcementClose.on('click', () => {
      $announcement.fadeOut();
    });
  };

  const initSideTab = () => {
    const $sideTab = $body.find('.side-tab');
    const $sideTabBtn = $sideTab.find('.side-tab__btn');

    $sideTabBtn.on('click', () => {
      $sideTab.toggleClass('is-open');
    });
  }

  const updateHeader = () => {
    const st = $(window).scrollTop();

    if (st > 50) {
      $header.addClass('is-scrolling');

      if (st > 250) {
        // difference between last and current scroll position
        const delta = lastSrollTop - st;

        if (delta < 0) {
          $header.addClass('is-hidden');
        } else {
          $header.removeClass('is-hidden');
        }
      }
    } else {
      $header.removeClass('is-scrolling is-hidden');
    }

    lastSrollTop = st;
  };

  const doneResizing = debounce(() => {
    const width = $(window).width();

    if (wWidth !== width) {
      wWidth = width;

      if (navState && wWidth >= 1024) {
        navState = !navState;
        $header.removeClass('is-opened');
        if (isScrollingDisabled) {
          enableScrolling();
        }
      }
    }
  }, 500);

  /* FUNCTION CALLS */
  /* ============= */
  bindEvents();
  initCarousel();
  initSlider();
  initFAQ();
  initParallax();
  initStorytellerParallax();
  initFaqParallax();
  initDoubleImageParallax();
  initHeader();
  initMenuNav();
  initHomeHeroParallax();
  initPageHeroParallax();
  initBackgroundShift();
  initGallery();
  initAnnouncement();
  initPromotionalPopup();
  initSideTab();


  if (isObserver) {
    $('.js-visibility').each((i, el) => {
      observer.observe(el);
    });
  }

  $(window).on('scroll', updateHeader);
  $(window).on('resize', doneResizing);
});
